export const GET_DEVICES = "GET_DEVICES";
export const ADD_DEVICE = "ADD_DEVICE";
export const DELETE_DEVICE = "DELETE_DEVICE";
export const DEVICES_LOADING = "DEVICES_LOADING";

export const GET_USERS_DEVICES = "GET_USERS_DEVICES";
export const DELETE_USERS_DEVICES = "DELETE_USERS_DEVICES";
export const USERS_DEVICES_LOADING = "USERS_DEVICES_LOADING";
export const GET_USERS_DEVICES_LOGS = "GET_USERS_DEVICES_LOGS";
export const USERS_DEVICES_LOGS_LOADING = "USERS_DEVICES_LOGS_LOADING";

export const INACTIVE_USERS_LOADING = "INACTIVE_USERS_LOADING";
export const GET_INACTIVE_USERS = "GET_INACTIVE_USERS";
export const DELETE_INACTIVE_USERS = "DELETE_INACTIVE_USERS";

export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
